import "./Nav.css";

function Nav() {
	return (
		<header className="fixed-top bg glass">
			<nav className="navbar navbar-dark navbar-expand-lg px-sm-5">
				<div className="container-fluid">
					<a className="navbar-brand color-300" href="/">
						Inicio
					</a>
					<button
						className="navbar-toggler box"
						type="button"
						data-bs-toggle="collapse"
						data-bs-target="#navbarNavAltMarkup"
						aria-controls="navbarNavAltMarkup"
						aria-expanded="false"
						aria-label="Toggle navigation"
					>
						<span className="navbar-toggler-icon"></span>
					</button>
					<div className="collapse navbar-collapse" id="navbarNavAltMarkup">
						<div className="navbar-nav">
							<a className="nav-link color-600 fs-5" href="/projetos">
								Projetos
							</a>
						</div>
					</div>
				</div>
			</nav>
		</header>
	);
}

export default Nav;
